<template lang="html">
    <div>
        <div v-if="loading">
            <div style="text-align:center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-if="loading == false">
            <div class="row">
                <div class="col-md-12">
                    <div class="box">
                        <div class="box-body">
                            <div class="clearfix">
                                <div class="float-md-left" style="margin-top: 5px;">
                                    <label>Tarih Aralığı</label>
                                </div>
                                <div class="float-md-left" style="margin-left: 10px;">
                                    <daterange :dateRange="filters.dateRange" v-on:onChange="onDateFilterChanged" opens="center" :showName="false" />
                                </div>
                                <div class="float-md-left" style="margin-left: 10px; margin-top: 3px;">
                                    <button type="button" v-on:click="submit" :disabled="saving" class="btn btn-success btn-xs">
                                        <span v-if="saving == false">Oluştur</span>
                                        <span v-if="saving">Lütfen bekleyiniz...</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="box">
                        <table class="table table-striped table-bordered">
                            <thead>
                            <tr>
                                <th>Oluşturulma Tarihi</th>
                                <th>Tamamlanma Tarihi</th>
                                <th style="width: 200px;">İşlem <button v-on:click="refresh()"><span class="fa fa-refresh"></span></button> </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in items">
                                <td>{{formatDate(item.createdAt)}}</td>
                                <td>{{formatDate(item.completedAt)}}</td>
                                <td>
                                    <button v-if="item.status == 1" v-on:click="download(item.id)" class="btn-mini btn btn-success" style="padding: 2px 8px;"><span class="fa fa-download"></span></button>
                                    <label v-if="item.status == 0" class="tag tag-warning">Rapor Oluşturuluyor</label>
                                </td>
                            </tr>
                            <tr v-if="!items">
                                <td colspan="2">
                                    <div class="alert alert-info">
                                        Herhangi bir rapor bulunmamakta.
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRange from '../../../components/daterange.vue';
    import moment from 'moment';

    export default {
        components: {
            'daterange': DateRange
        },
        data: function () {
            return {
                filters: {
                    dateRange: [moment(), moment()]
                },
                items: [],
                loading: false,
                saving: false
            }
        },
        mounted: function () {
            this.refresh();
        },
        methods: {
            submit: function () {
                var $this = this;
                var params = {
                    report_type: 'RefundMaya',
                    report_params: {
                        date_range: [
                            this.filters.dateRange[0].format('YYYY-MM-DD 00:00:00'),
                            this.filters.dateRange[1].format('YYYY-MM-DD 23:59:59')
                        ]
                    }
                };
                this.loading = true;
                this.$app.post('/api/v1/report-files', params, function (xhr) {
                    var response = xhr.responseJSON;
                    $this.refresh();
                });
            },
            download: function (id) {
                window.open('/api/v1/report-files/download?report_file_id=' + id + '&access_token=' + this.$app.getUser().token.access_token);
            },
            refresh: function () {
                var $this = this;
                this.loading = true;
                $this.$app.get('/api/v1/report-files/search', {report_type: 'RefundMaya'}, function(xhr) {
                    var response = xhr.responseJSON;
                    $this.items = response.files;
                    $this.loading = false;
                });
            },
            formatDate: function (date) {
                return moment(date,  'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm:ss');
            },
            onDateFilterChanged: function (data) {
                this.filters.dateRange = data;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// maya.vue?079ef60e